module.exports = __webpack_public_path__ + "static/media/ref.5c9dd12e.png";